import { NoParamEndpointConstructor, SingleParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/prgm/dictionaries/alert-conditions'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  update: SingleParamEndpointConstructor
}

export const alertManualEndpoints: Endpoints = {
  getAll: () => `${baseUrl}`,
  update: (id) => `${baseUrl}/${id}`,
}
